import { create } from 'zustand';

export type NotificationType = 'feedback' | 'assignment' | 'system';

export interface NotificationPayload {
    targetText?: string;
    overlay?: unknown; // InputStroke[]
    originalStrokes?: unknown[]; // InputStroke[]
}

export interface Notification {
    id: string;
    title: string;
    message: string;
    timestamp: number;
    read: boolean;
    type: NotificationType;
    payload?: NotificationPayload;
}

interface NotificationState {
    unreadCount: number;
    notifications: Notification[];
    addNotification: (notification: Notification) => void;
    markAsRead: (id: string) => void;
    clearAll: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
    unreadCount: 0,
    notifications: [],
    addNotification: (notification) =>
        set((state) => {
            // Prevent duplicate IDs from being added
            if (state.notifications.some((n) => n.id === notification.id)) {
                return {};
            }

            return {
                notifications: [notification, ...state.notifications],
                unreadCount: notification.read ? state.unreadCount : state.unreadCount + 1,
            };
        }),
    markAsRead: (id) =>
        set((state) => {
            const notification = state.notifications.find((n) => n.id === id);

            // If not found or already read, no changes
            if (!notification || notification.read) return {};

            return {
                notifications: state.notifications.map((n) =>
                    n.id === id ? { ...n, read: true } : n
                ),
                unreadCount: Math.max(0, state.unreadCount - 1),
            };
        }),
    clearAll: () => set({ notifications: [], unreadCount: 0 }),
}));
